import type React from 'react';

function DeutschePostIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 169 169"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Deutsche Post Icon</title>

      <g id="svg1898">
        <g id="layer1">
          <g id="g2038">
            <g id="g2017">
              <polygon
                id="_225737648"
                data-name=" 225737648"
                points="57.54 128.05 79.3 128.05 57.32 150.28 35.57 150.28 57.54 128.05"
              />

              <polygon
                id="_229043400"
                data-name=" 229043400"
                points="28.19 128.05 49.95 128.05 27.97 150.28 6.21 150.28 28.19 128.05"
              />

              <polygon
                id="_226455448"
                data-name=" 226455448"
                points="106.1 128.05 84.35 128.05 106.32 150.28 128.08 150.28 106.1 128.05"
              />

              <polygon
                id="_227904456"
                data-name=" 227904456"
                points="135.46 128.05 113.7 128.05 135.67 150.28 157.43 150.28 135.46 128.05"
              />

              <path
                id="path2012"
                d="M122.11,66.34c3.77-10.28,6.39-25.93,6.94-36.88l38.6,9.6c-3.09,45.31-37.08,85-87.49,84.98-57.03-.03-79.07-49.6-76.11-87.18l16.75-5.33c-2.72,21.38,3.89,36.79,8.46,43.87-5.43-30.25,17.4-54.74,45.98-54.75,25.7-.02,46.96,18.75,46.87,45.68h0Zm-77.68,.95h0c0,17.06,13.83,30.9,30.9,30.9s30.89-13.83,30.89-30.9-13.83-30.89-30.89-30.89-30.9,13.83-30.9,30.89Z"
              />
            </g>
          </g>
        </g>
        <rect width="169" height="169" fill="none" />
      </g>
    </svg>
  );
}

export default DeutschePostIcon;
